import { Component, OnInit } from '@angular/core';
import {Constant} from '../../../../../shared/constants/constant.class';

@Component({
  selector: 'app-warehouse-hub',
  templateUrl: './warehouse-hub.component.html',
  styleUrls: ['./warehouse-hub.component.scss']
})
export class WarehouseHubComponent implements OnInit {
  isMaster = false;
  isLab = false;
  constructor() { }

  ngOnInit(): void {
    this.isMaster = +localStorage.getItem(Constant.WAREHOUSE_ID) === 1 ? true : false;

  }

}
